import { ReactNode } from "react";
import NewsSide from "../components/NewsSide";
import SystemSide from "../components/SystemSide";
import HeaderLayout from "../layouts/HeaderLayout";

function HomePage() {
  return (
    <HeaderLayout>
      <div className="max-md:h-screen max-md:overflow-y-auto max-md:overscroll-contain">
        <div className="sm:container mx-auto max-sm:px-[24px] max-md:px-7.5 px-10">
          <div className="flex flex-row max-md:flex-wrap-reverse justify-between gap-7.5 max-md:gap-y-7.5 max-sm:py-[24px] max-md:py-7.5">
            <HomePageSideLayout>
              <SystemSide />
            </HomePageSideLayout>
            <HomePageSideLayout className="max-sm:hidden">
              <NewsSide />
            </HomePageSideLayout>
          </div>
        </div>
      </div>
    </HeaderLayout>
  );
}

function HomePageSideLayout({ children, className }: { children: ReactNode, className?: string }) {
  return (
    <div className={`flex flex-col w-1/2 max-md:w-full p-0 sm:pr-2.5 md:py-5 scrollbar-thumb-rounded scrollbar-thin scrollbar-w-2 scrollbar-thumb-[#dfe4ea] scrollbar-track-inherit md:max-h-[calc(100vh-81px)] overflow-auto max-md:overflow-visible ${className}`}>
      {children}
    </div>
  );
}

export default HomePage;
